import {
    RaikoBaseCardContainer, RaikoConfirmDialog,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoSectionContainer, RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {OccasionalService} from "../../../serverService/occasional/OccasionalService";
import React, {useEffect,useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function OccasionalBannerDetailsPublicationStatus({bannerId}) {

    const service = new OccasionalService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false)
    const [published, setPublished] = useState(false)

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }


    useEffect(() => {
        loading.show()

        service.getBannerPublishedStateById(bannerId)
            .then(response => {
                setPublished(response.published)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }, [bannerId]);

    function handleChangeEnableSetting() {
        loading.show()
        service.changePublishedState(bannerId, !published)
            .then(response => {
                setPublished(response.published)

                if (response.published)
                    showSuccessMessage("بنر مناسبتی با موفقیت منتشر شد.")
                else
                    showWarningMessage("بنر مناسبتی با موفقیت غیرفعال شد.")

                handleCloseConfirmDialog()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"وضعیت انتشار"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!published ? "انتشار" : "عدم انتشار"}
                />
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    hasHelperButton
                    helperContent={
                    <RaikoBaseDialogContentContainer>
                        <RaikoLabel text={"* با فعالسازی این مورد کاربران قادر به مشاهده ی این بنر مناسبتی خواهند بود و در غیر این صورت بنر مناسبتی تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند."}/>
                    </RaikoBaseDialogContentContainer>
                    }
                >
                    <RaikoToggleOutlined
                        labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                        setChecked={state => {
                            setConfirmDialogOpenState(true)
                        }}
                        checked={published}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </>
    )
}